import React from 'react';

import { SelectPageSize } from '@portal/components/common/SelectPageSize.ui';
import { TypographyUI } from '@portal/components/common/Typography.ui';

export const TableCountPageSizeSelectorUI = ({
  totalData,
  totalFilteredData,
  selectedPageSize,
  setPageSize,
}: {
  totalData: number;
  totalFilteredData: number;
  selectedPageSize: number;
  setPageSize: (pageSize: number) => void;
}) => {
  return (
    <div className='w-full flex items-center justify-between'>
      <TypographyUI className='text-tl'>
        Total {totalData} servers{' '}
        {totalFilteredData !== 0 && totalFilteredData !== totalData && `(${totalFilteredData} after filtered)`}
      </TypographyUI>
      <SelectPageSize
        totalData={totalData}
        selectedPageSize={selectedPageSize}
        onSelectedPageSizeChange={setPageSize}
      />
    </div>
  );
};
